import React from 'react';
import PrimaryButton from '../components/PrimaryButton';
import { TwoFactorAuthenticationMethods } from '@tradingblock/types';
;
const Success = ({ verifiedTwoFactorAuthenticationMethod, twoFactorAuthenticationSetupComplete, primaryButtonProps, }) => {
    const getTwoFactorAuthenticationMethodText = () => {
        if (verifiedTwoFactorAuthenticationMethod === TwoFactorAuthenticationMethods.email) {
            return 'email';
        }
        else if (verifiedTwoFactorAuthenticationMethod === TwoFactorAuthenticationMethods.sms) {
            return 'text';
        }
        return '';
    };
    if (verifiedTwoFactorAuthenticationMethod) {
        return (React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "You have successfully verified ",
                getTwoFactorAuthenticationMethodText(),
                " two-factor authentication (2FA)."),
            React.createElement("div", { className: "btn-wrapper" },
                React.createElement(PrimaryButton, Object.assign({}, primaryButtonProps)))));
    }
    if (twoFactorAuthenticationSetupComplete) {
        return (React.createElement(React.Fragment, null,
            React.createElement("p", null, "Two-factor authentication (2FA) is now enabled. Your account is now protected."),
            React.createElement("div", { className: "btn-wrapper" },
                React.createElement(PrimaryButton, Object.assign({}, primaryButtonProps)))));
    }
    return React.createElement(React.Fragment, null);
};
export default Success;
//# sourceMappingURL=Success.js.map